import {
  ActionIcon,
  Badge,
  Center,
  Group,
  Pagination,
  Paper,
  ScrollArea,
  SimpleGrid,
  Switch,
  Table,
  Text,
  TextInput,
} from "@mantine/core";

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowDown, ArrowUp, Search } from "tabler-icons-react";
import ConfirmToggleModal from "../adminConfirmToggle/ConfirmToggleModal";
import Button from "../Button";
import Paginating from "./paginating";

const TableComponent = ({
  cancelled,
  setCancelled,
  axiosFunction,
  blockURL,
  unblockURL,
  blockingParam,
  headCells,
  rowData,
  setViewModalData,
  setViewModalState,
  setOpened,
  showAddButton,
  setUpdate,
  setEditData,
  setDeleteModalState,
  setEditModalState,
  setDeleteData,
}) => {
  // console.log("rowData", rowData);
  useEffect(() => {
    setRowDatas(rowData);
  }, [rowData]);

  const [updateData, setUpdateData] = useState({});
  //
  const [currentStatus, setCurrentStatus] = useState(null);
  const [openedState, setOpenedState] = useState(false);
  const [rowDatas, setRowDatas] = useState(rowData);
  const [sorted, setSorted] = useState({ sorted: "", reversed: false });
  const [searchPhrase, setSearchPhrase] = useState("");
  const [activePage, setPage] = useState(1);

  // Location
  const location = useLocation();

  //make pagination logic
  const itemsPerPage = 15;
  const pages = Math.ceil(rowDatas.length / itemsPerPage);
  const start = (activePage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  const paginatedRowData = rowDatas.slice(start, end);

  const sortNumericValue = (label) => {
    setSorted({
      sorted: label,
      reversed: !sorted.reversed,
    });

    const rowDataCopy = [...rowDatas];
    rowDataCopy.sort((dataA, dataB) => {
      if (sorted.reversed === true) {
        return dataB[label] - dataA[label];
      }
      return dataA[label] - dataB[label];
    });
    setRowDatas(rowDataCopy);
  };
  const sortStringValue = (label) => {
    setSorted({ sorted: label, reversed: !sorted.reversed });
    const rowDataCopy = [...rowDatas];
    rowDataCopy.sort((dataA, dataB) => {
      if (sorted.reversed === true) {
        return dataA[label]?.localeCompare(dataB[label]);
      }
      return dataB[label]?.localeCompare(dataA[label]);
    });
    setRowDatas(rowDataCopy);
  };

  const search = (event) => {
    const matchedData = rowData.filter((data) => {
      let searchObject = {};
      headCells.map((head) => {
        if (head.id in data) {
          searchObject[head.id] = data[head.id];
        }
      });
      for (let i = 0; i < Object.values(searchObject).length; i++) {
        if (
          Object.values(searchObject)
            [i].toString()
            .toLowerCase()
            .includes(event.target.value.toString().toLowerCase())
        ) {
          return true;
        }
      }
    });
    setSorted({ sorted: "", reversed: false });
    setRowDatas(matchedData);
    setSearchPhrase(event.target.value);
  };

  return (
    <Paper component={ScrollArea} w={"100%"}>
      <ConfirmToggleModal
        setUpdate={setUpdate}
        //
        axiosFunction={axiosFunction}
        blockURL={blockURL}
        unblockURL={unblockURL}
        blockingParam={blockingParam}
        updateData={updateData}
        currentStatus={currentStatus}
        //
        cancelled={cancelled}
        openedState={openedState}
        setCancelled={setCancelled}
        setOpenedState={setOpenedState}
      />
      <Paper p={"xs"} w={"100%"}>
        <Group position={showAddButton ? "apart" : "right"} noWrap>
          {showAddButton && (
            <Button
              title={"Add"}
              primary={true}
              fontWeight="700"
              onClick={() => {
                setOpened(true);
              }}
            />
          )}

          <TextInput
            value={searchPhrase}
            onChange={search}
            icon={<Search />}
            placeholder={"Search"}
          />
        </Group>
      </Paper>

      <Table striped withBorder withColumnBorders width={"100%"}>
        <thead>
          <tr>
            {headCells?.map((head, index) => {
              return (
                <th
                  key={index}
                  style={{
                    whiteSpace: "nowrap",
                    width: head.id === "id" ? "50px" : "auto",
                  }}
                  onClick={() => {
                    head.numeric === true
                      ? sortNumericValue(head.id)
                      : sortStringValue(head.id);
                  }}
                >
                  <Group
                    style={{ flexWrap: "nowrap", flexShrink: 0 }}
                    spacing={3}
                    align={"center"}
                    position={head.numeric === true ? "right" : "left"}
                  >
                    <Text>{head?.label}</Text>
                    {head.id !== "actions" &&
                      (!sorted.reversed === true &&
                      sorted.sorted === head.id ? (
                        <ArrowDown size={16} />
                      ) : (
                        <ArrowUp size={16} />
                      ))}
                  </Group>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {paginatedRowData?.map((row, index) => {
            return (
              <tr key={index}>
                {headCells?.map((head, index) => {
                  return head.id === "actions" ? (
                    <td key={index}>
                      <Group position="center">
                        <ActionIcon
                          onClick={() => {
                            setViewModalState(true);
                            setViewModalData(row);
                          }}
                        >
                          {head.view}
                        </ActionIcon>
                        {head.edit && (
                          <ActionIcon
                            onClick={() => {
                              setEditModalState(true);
                              setEditData(row);
                              setOpened(true);
                            }}
                          >
                            {head.edit}
                          </ActionIcon>
                        )}
                        {head.delete && (
                          <ActionIcon
                            onClick={() => {
                              setDeleteModalState(true);
                              setDeleteData(row);
                            }}
                          >
                            {head.delete}
                          </ActionIcon>
                        )}
                      </Group>
                    </td>
                  ) : (
                    <td
                      key={index}
                      align={
                        typeof row[head?.id] === "number" ||
                        head.id === "actions" ||
                        head.id === "status"
                          ? "center"
                          : "left"
                      }
                    >
                      {head.date ? (
                        row[head?.id]?.split("T")[0] +
                        " " +
                        row[head?.id]?.split("T")[1].split(".")[0]
                      ) : head.id === "status" ||
                        (head.id === "state" &&
                          location.pathname.includes([
                            "/viewJobSeekers",
                            "/viewCompanies",
                            "/viewAdmins",
                          ])) ? (
                        <Switch
                          hidden={true}
                          defaultChecked={
                            row[head?.id] === "active" ? true : false
                          }
                          onChange={(e) => {
                            e.preventDefault();
                            setUpdateData(row);
                            setCurrentStatus(row[head?.id]);
                            setOpenedState(true);
                            if (cancelled) {
                              e.target.checked = true;
                            } else if (!cancelled) {
                              e.target.checked = true;
                            }
                          }}
                          label={row[head?.id]}
                          color={row[head?.id] === "active" ? "green" : "red"}
                        />
                      ) : head.id === "email" ? (
                        <Group position="apart" align="center">
                          <Text>{row[head?.id]?.toLocaleString()}</Text>
                          <Badge
                            size="md"
                            color={row.emailVerified ? "green" : "red"}
                          >
                            {row.emailVerified ? "Verified" : "Not Verified"}
                          </Badge>
                        </Group>
                      ) : head.id === "empLocation.locationName" ? (
                        <Text>{row?.empLocation?.locationName}</Text>
                      ) : (
                        <Text lineClamp={1}>
                          {row[head?.id].length > 100
                            ? row[head?.id].substring(0, 100) + "..."
                            : row[head?.id].toLocaleString()}
                        </Text>
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Center>
        <Paginating
          pages={pages}
          activePage={activePage}
          totalCount={pages}
          setPage={setPage}
        />
      </Center>
    </Paper>
  );
};

export default TableComponent;

// SAMPLE COMPPONENT REMOVED, DO NOT DELETE CODE!
